import { NavigationDragDropActions } from '@common/enums/navigation-drag-drop-actions';

export class NavigationDragDropData {
    public action: NavigationDragDropActions;
    public data: any;
}
